import { UID, getColumns } from "./common";

export default {
  columns: getColumns({
    header: "Authorization",
    subheader:
      "When a customer authorizes a payment, their bank guarantees the amount and holds it on their card for up to seven days."
  }),
  rows: [
    {
      title: {
        value: "Authorize and hold",
        tooltip: "Sellers can capture all or part of funds held."
      },
      stripe: {
        uid: UID.STRIPE,
        enabled: false
      },
      priceblocs: {
        uid: UID.PRICEBLOCS,
        enabled: true
      }
    }
  ]
};
